"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHDPath = exports.toNumber = void 0;
const toNumber = (num) => {
    const isHardened = /'$/.test(num);
    return isHardened ? +num.slice(0, -1) : +num;
};
exports.toNumber = toNumber;
const parseHDPath = (hdPath) => {
    const path = hdPath.split(/\//);
    return {
        coinType: exports.toNumber(path[2]),
        bip44HDPath: {
            account: exports.toNumber(path[3]),
            change: exports.toNumber(path[4]),
            addressIndex: exports.toNumber(path[5]),
        },
    };
};
exports.parseHDPath = parseHDPath;
//# sourceMappingURL=utils.js.map